import {useMutation} from "@tanstack/react-query";
import {addFacilityUsers} from "../services/FacilityService";

export function useFacilityUsersAdd() {
    return useMutation({
        mutationFn: ({facilityId, userIds}) => addFacilityUsers(facilityId, userIds),
    });
}
